import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <p data-testid="footer" className="text-center my-4">
      @ Created by{" "}
      
        Akash Kumar Sadangi
     
    </p>
  );
};

export default Footer;
